var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStep332(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_923_1946)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16.7266,
    r: 16,
    fill: "#F3FAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.564 14.184C19.564 14.696 19.4573 15.144 19.244 15.528C19.0413 15.912 18.7587 16.2267 18.396 16.472C18.0333 16.7067 17.612 16.8773 17.132 16.984V17.032C18.0493 17.1387 18.7427 17.4213 19.212 17.88C19.6813 18.3387 19.916 18.9467 19.916 19.704C19.916 20.3653 19.756 20.9573 19.436 21.48C19.116 22.0027 18.62 22.4133 17.948 22.712C17.2867 23.0107 16.4333 23.16 15.388 23.16C14.7693 23.16 14.1933 23.1067 13.66 23C13.1267 22.904 12.6253 22.7493 12.156 22.536V20.76C12.636 21.0053 13.148 21.192 13.692 21.32C14.236 21.448 14.748 21.512 15.228 21.512C16.156 21.512 16.812 21.3467 17.196 21.016C17.58 20.6747 17.772 20.2053 17.772 19.608C17.772 19.224 17.676 18.9093 17.484 18.664C17.292 18.4187 16.9773 18.2373 16.54 18.12C16.1133 17.992 15.5533 17.928 14.86 17.928H13.9V16.312H14.876C15.548 16.312 16.076 16.2373 16.46 16.088C16.8547 15.9387 17.132 15.7307 17.292 15.464C17.4627 15.1973 17.548 14.888 17.548 14.536C17.548 14.0773 17.3987 13.72 17.1 13.464C16.8013 13.208 16.3533 13.08 15.756 13.08C15.372 13.08 15.0253 13.1227 14.716 13.208C14.4067 13.2933 14.124 13.4053 13.868 13.544C13.612 13.672 13.372 13.8107 13.148 13.96L12.188 12.568C12.476 12.3547 12.8013 12.1627 13.164 11.992C13.5267 11.8107 13.932 11.672 14.38 11.576C14.828 11.4693 15.3187 11.416 15.852 11.416C17.036 11.416 17.948 11.6667 18.588 12.168C19.2387 12.6587 19.564 13.3307 19.564 14.184Z",
    fill: "#1778E1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_923_1946"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.726562)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep332);
export default __webpack_public_path__ + "static/media/step-3-32.e14a97e9.svg";
export { ForwardRef as ReactComponent };